<template>
  <div>
    <a-button type="primary" :style="{ margin: '0 0 24px 0' }" @click="addRecord">
      新增函数配置
    </a-button>
    <a-table
      :columns="columns"
      :row-key="record => record.id"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="status" slot-scope="text, record">
        <a-switch
          :checked="record.status === 1"
          checked-children="启用"
          un-checked-children="禁用"
          @change="toggleStatus(record)"
        />
      </template>
      <template slot="functionDesc" slot-scope="text">
        <a-tooltip :title="text">
          <span>{{ text && text.length > 30 ? text.substring(0, 30) + '...' : text }}</span>
        </a-tooltip>
      </template>
      <template slot="parametersSchema" slot-scope="text">
        <a-tooltip :title="text">
          <span>{{ text && text.length > 30 ? text.substring(0, 30) + '...' : text }}</span>
        </a-tooltip>
      </template>
      <template slot="createTime" slot-scope="text">
        {{ text ? dayjs(text).format('YYYY-MM-DD HH:mm') : '-' }}
      </template>
      <template slot="operate" slot-scope="text, record">
        <a href="javascript:;" @click="editRecord(record)">编辑</a>
        <a-divider type="vertical" />
        <a href="javascript:;" @click="delRecord(record)">删除</a>
      </template>
    </a-table>

    <!-- 新增/编辑弹窗 -->
    <a-modal v-model="visible" :title="modalTitle" @ok="handleOk" width="780px">
      <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-item label="函数名称">
          <a-input v-model="form.functionName" placeholder="AI调用标识，如createProduct" />
        </a-form-item>
        <a-form-item label="函数描述">
          <a-textarea v-model="form.functionDesc" :rows="3" placeholder="告诉AI这个函数的用途" />
        </a-form-item>
        <a-form-item label="参数定义">
          <div>
            <a-button size="small" icon="plus" @click="addParam" :style="{ marginBottom: '8px' }">添加参数</a-button>
            <div v-for="(param, index) in form.parameters" :key="index" :style="{ border: '1px solid #e8e8e8', borderRadius: '4px', padding: '12px', marginBottom: '8px', background: '#fafafa' }">
              <a-row :gutter="8">
                <a-col :span="5">
                  <a-input v-model="param.name" placeholder="参数名称" size="small" />
                </a-col>
                <a-col :span="4">
                  <a-select v-model="param.type" placeholder="类型" size="small" style="width: 100%">
                    <a-select-option value="string">string</a-select-option>
                    <a-select-option value="number">number</a-select-option>
                    <a-select-option value="integer">integer</a-select-option>
                    <a-select-option value="boolean">boolean</a-select-option>
                    <a-select-option value="array">array</a-select-option>
                    <a-select-option value="object">object</a-select-option>
                  </a-select>
                </a-col>
                <a-col :span="8">
                  <a-input v-model="param.description" placeholder="参数描述" size="small" />
                </a-col>
                <a-col :span="3">
                  <a-switch v-model="param.required" checked-children="必填" un-checked-children="选填" size="small" />
                </a-col>
                <a-col :span="4">
                  <a-button size="small" icon="delete" type="danger" ghost @click="removeParam(index)">删除</a-button>
                </a-col>
              </a-row>
              <a-row :gutter="8" :style="{ marginTop: '8px' }">
                <a-col :span="5">
                  <span style="color: #666; font-size: 12px; line-height: 32px;">默认值</span>
                </a-col>
                <a-col :span="10">
                  <a-input v-model="param.defaultValue" placeholder="默认值（可选）" size="small" />
                </a-col>
              </a-row>
            </div>
            <div v-if="!form.parameters || form.parameters.length === 0" style="color: #999; text-align: center; padding: 12px;">暂无参数定义，点击"添加参数"新增</div>
          </div>
        </a-form-item>
        <a-form-item label="处理Bean">
          <a-input v-model="form.handlerBean" placeholder="Spring Bean Name" />
        </a-form-item>
        <a-form-item label="使用场景">
          <a-select v-model="form.scenario" placeholder="请选择使用场景">
            <a-select-option value="default">默认(default)</a-select-option>
            <a-select-option value="product">商品(product)</a-select-option>
            <a-select-option value="order">订单(order)</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="排序">
          <a-input-number v-model="form.sortOrder" :min="0" style="width: 100%" placeholder="数值越小越靠前" />
        </a-form-item>
        <a-form-item label="状态">
          <a-switch v-model="statusChecked" checked-children="启用" un-checked-children="禁用" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import {
  getAiFunctionList,
  addAiFunction,
  editAiFunction,
  deleteAiFunction,
  updateAiFunctionStatus
} from "@/api/homeApi.js";
import { message } from "ant-design-vue";
import dayjs from "dayjs";

var columns = [
  { title: "ID", dataIndex: "id", align: "center", width: 60 },
  { title: "函数名称", dataIndex: "functionName", align: "center" },
  { title: "函数描述", dataIndex: "functionDesc", align: "center", scopedSlots: { customRender: "functionDesc" } },
  { title: "参数Schema", dataIndex: "parametersSchema", align: "center", scopedSlots: { customRender: "parametersSchema" } },
  { title: "处理Bean", dataIndex: "handlerBean", align: "center" },
  { title: "使用场景", dataIndex: "scenario", align: "center", width: 100 },
  { title: "排序", dataIndex: "sortOrder", align: "center", width: 70 },
  { title: "状态", dataIndex: "status", align: "center", scopedSlots: { customRender: "status" }, width: 100 },
  { title: "创建时间", dataIndex: "createTime", align: "center", scopedSlots: { customRender: "createTime" }, width: 150 },
  { title: "操作", dataIndex: "operate", align: "center", width: 120, scopedSlots: { customRender: "operate" } }
];

export default {
  props: ["formInline"],
  data: function () {
    return {
      data: [],
      loading: false,
      columns: columns,
      visible: false,
      modalTitle: "新增函数配置",
      form: this.initForm(),
      statusChecked: true,
      dayjs: dayjs,
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: function (total) { return "共 " + total + " 条"; },
        pageSize: 10
      }
    };
  },
  mounted: function () {
    this.getData();
  },
  methods: {
    initForm: function () {
      return {
        id: null,
        functionName: "",
        functionDesc: "",
        parameters: [],
        handlerBean: "",
        scenario: "default",
        status: 1,
        sortOrder: 0
      };
    },
    getData: function () {
      var self = this;
      self.loading = true;
      var params = {
        page: self.pagination.current,
        limit: self.pagination.pageSize
      };
      if (self.formInline && self.formInline.functionName) {
        params.functionName = self.formInline.functionName;
      }
      if (self.formInline && self.formInline.scenario) {
        params.scenario = self.formInline.scenario;
      }
      getAiFunctionList(params).then(function (res) {
        self.loading = false;
        if (res && res.data) {
          self.data = Array.isArray(res.data) ? res.data : [res.data];
          self.pagination.total = res.count || self.data.length;
        } else {
          self.data = [];
          message.info("暂无数据");
        }
      }).catch(function () {
        self.loading = false;
      });
    },
    handleTableChange: function (pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getData();
    },
    addRecord: function () {
      this.modalTitle = "新增函数配置";
      this.form = this.initForm();
      this.statusChecked = true;
      this.visible = true;
    },
    editRecord: function (row) {
      this.modalTitle = "编辑函数配置";
      var params = [];
      if (row.parameters && Array.isArray(row.parameters)) {
        params = row.parameters.map(function (p) {
          return {
            name: p.name || "",
            type: p.type || "string",
            description: p.description || "",
            required: p.required || false,
            defaultValue: p.defaultValue !== undefined && p.defaultValue !== null ? String(p.defaultValue) : ""
          };
        });
      }
      this.form = {
        id: row.id,
        functionName: row.functionName || "",
        functionDesc: row.functionDesc || "",
        parameters: params,
        handlerBean: row.handlerBean || "",
        scenario: row.scenario || "default",
        status: row.status != null ? row.status : 1,
        sortOrder: row.sortOrder || 0
      };
      this.statusChecked = row.status === 1;
      this.visible = true;
    },
    handleOk: function () {
      if (!this.form.functionName) {
        message.warning("函数名称不能为空");
        return;
      }
      if (!this.form.handlerBean) {
        message.warning("处理Bean名称不能为空");
        return;
      }
      this.form.status = this.statusChecked ? 1 : 0;
      var params = Object.assign({}, this.form);
      // 将 enumValuesStr 转为 enumValues 数组
      if (params.parameters && params.parameters.length > 0) {
        params.parameters = params.parameters.map(function (p) {
          var item = {
            name: p.name,
            type: p.type,
            description: p.description,
            required: p.required
          };
          if (p.defaultValue !== undefined && p.defaultValue !== null && p.defaultValue !== "") {
            var val = p.defaultValue;
            if (p.type === "number" || p.type === "integer") {
              val = Number(val);
            } else if (p.type === "boolean") {
              val = val === "true" || val === true;
            }
            item.defaultValue = val;
          }
          return item;
        });
      }
      this.visible = false;
      var api = this.form.id ? editAiFunction : addAiFunction;
      api(params).then(function (res) {
        message.success(res.info || "操作成功");
        this.getData();
      }.bind(this)).catch(function () {
        message.error("操作失败");
      });
    },
    delRecord: function (row) {
      var self = this;
      this.$confirm({
        title: "确认删除",
        content: '确定要删除函数配置"' + row.functionName + '"吗？',
        onOk: function () {
          return deleteAiFunction(row.id).then(function (res) {
            message.success(res.info || "删除成功");
            self.getData();
          });
        }
      });
    },
    addParam: function () {
      if (!this.form.parameters) {
        this.form.parameters = [];
      }
      this.form.parameters.push({
        name: "",
        type: "string",
        description: "",
        required: false,
        defaultValue: ""
      });
    },
    removeParam: function (index) {
      this.form.parameters.splice(index, 1);
    },
    toggleStatus: function (row) {
      var newStatus = row.status === 1 ? 0 : 1;
      updateAiFunctionStatus(row.id, newStatus).then(function (res) {
        message.success(res.info || "操作成功");
        this.getData();
      }.bind(this)).catch(function () {
        message.error("操作失败");
      });
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/systemManagement/aiFunctionConfig/aiFunctionConfig.vue